import { styled, Dialog, Button, DialogActions, DialogContent, IconButton, DialogTitle, CircularProgress } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close'
import styles from './HostServicesLoadingProgressDialog.module.css'

interface LoadingDataDialogProps {
    open: boolean,
    onOpenChange?: Function,
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
    '& .MuiDialog-paper': {
        width: 'auto',
        maxHeight: '590px',
        maxWidth: '100%'
    }
}));

export const HostServicesLoadingProgressDialog = (props: LoadingDataDialogProps): JSX.Element => {
    const {
        onOpenChange,
        open
    } = props

    const handleClose = () => {
            onOpenChange?.(false);
    }

    return (
        <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
        >
            <DialogTitle sx={{ minHeight: '52px', m: 0, p: 2 }} id="customized-dialog-title">
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent dividers>
                <h2>Searching for you competitors</h2>
                <div className={styles.HostServicesLoadingProgressDialog_ProgressContainer}>
                    <CircularProgress size="62px" />
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>
                    Close
                </Button>
            </DialogActions>
        </BootstrapDialog>
    )
}